import { brazeConstants } from '../constants/brazeConstants';

const initialState = {
	error: {},
	brazeResponse: {},
	brazrDetail: {},
	listbraze: {},
};

export default function brazeReducer(state= initialState, action) {
	switch (action.type) {
		case brazeConstants.BRAZE_REQUEST:
		return {
			sending: true
		};
		case brazeConstants.BRAZE_SUCCESS:
		return {
			...state,
			sending: false,
		brazeResponse: action.data
		};
		case brazeConstants.BRAZE_FAILURE:
		return {
			...state,
			sending: false,
			error: action.error
		};
		case brazeConstants.GET_BRAZE_REQUEST:
		return {
			sending: true
		};
		case brazeConstants.GET_BRAZE_SUCCESS:
		return {
			...state,
			sending: false,
			brazeDetail: action.data
		};
		case brazeConstants.GET_BRAZE_FAILURE:
		return {
			...state,
			sending: false,
			error: action.error
		};
		case brazeConstants.LIST_BRAZE_REQUEST:
	      return {
	        sending: true
	      };
	    case brazeConstants.LIST_BRAZE_SUCCESS:
           
            //console.log(action.data)
	      return {
	        ...state,
	        sending: false,
	        listbraze: action.data
	      };
	    case brazeConstants.LIST_BRAZE_FAILURE:
	      return {
	        ...state,
	        sending: false,
	        error: action.error
	      }; 
		default:
		return state
	}
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/brazeReducer.js